import React, { Component } from 'react';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import Paper from 'material-ui/Paper';

import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';

import Layout from '../Layout';

import changePassword from '../../actions/changePassword';
import PasswordForm from '../../containers/PasswordForm';
import getUrlParameter from '../../helpers/Util';
import autotecStyle from '../../components/Styles/style';
import RenderDialog from '../../helpers/RenderDialog';

class ChangePassword extends Component {
  constructor(props) {
    super(props);
    this.state = {
      message: null,
      changePasswordError: null
    };
  }
  handleSave = (event) => {
    const username = getUrlParameter('username');
    this.props.actions.changePassword(username, event.oldPassword, event.newPassword, this.props.data.config, this);
  }

  closeSuccess = () => {
    this.props.history.push('/');
  }

  closeError = () => {
    this.setState({ changePasswordError: null });
  }

  render() {
    let dialog = <div />;
    const { message, changePasswordError } = this.state;

    if (message) {
      dialog =
        (<RenderDialog
          open
          confirmButton
          message={message}
          onClose={this.closeSuccess}
        />);
    }

    if (changePasswordError) {
      dialog =
        (<RenderDialog
          open
          confirmButton
          message={changePasswordError.message}
          onClose={this.closeError}
        />);
    }

    const { classes } = this.props;
    return (
      <Layout className="App" showMenu menuTitle="" toolTip="Having problems? Please review the information you have entered to be sure everything is correct.  If you continue to have problems please contact our Customer Service department at (205) 414-2727.">
        <Paper className={classes.paperStyle}>
          <img src="logo.png" width="216" height="152" alt="" style={{ marginTop: '16px' }} />
          {dialog}
          <PasswordForm handleSave={this.handleSave} />
        </Paper>
      </Layout>
    );
  }
}

ChangePassword.propTypes = {
  classes: PropTypes.shape().isRequired
};

const mapStateToProps = state => ({
  data: {
    config: state.config.config
  }
});

const mapDispatchToProps = dispatch => ({
  actions: {
    changePassword: (username, oldPassword, newPassword, config, self) => {
      dispatch(changePassword(username, oldPassword, newPassword, config, self))
        .then((o) => {
          self.setState({ message: 'Password changed', changePasswordError: null });
        })
        .catch((error) => {
          self.setState({ message: null, changePasswordError: error });
        });
    }
  }
});

const ConnectedChangePassword = connect(
  mapStateToProps,
  mapDispatchToProps
)(ChangePassword);

export default withStyles(autotecStyle, { withTheme: true })(reduxForm({ form: 'ChangePasswordUserForm' })(ConnectedChangePassword));


// WEBPACK FOOTER //
// ./src/components/User/ChangePassword.js